import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/components/ui/Toast';
import {
  SpApiConnectionsPanel,
  SP_API_OAUTH_CONNECTIONS_QUERY_KEY,
} from '@/components/SpApiOauthConnections';
import { SignOutButton } from '@/components/auth/SignOutButton';

export function AdminSettingsPage() {
  const { showToast } = useToast();
  const [searchParams, setSearchParams] = useSearchParams();
  const qc = useQueryClient();

  useEffect(() => {
    const spapi = searchParams.get('spapi');
    if (!spapi) return;
    if (spapi === 'connected') {
      const kind = searchParams.get('type');
      const created = searchParams.get('created') !== '0';
      const vendorToast = created
        ? 'Vendor Central connected'
        : 'Already connected — updated existing Vendor account';
      const sellerToast = created
        ? 'Seller Central connected'
        : 'Already connected — updated existing Seller account';
      showToast(
        kind === 'vendor'
          ? vendorToast
          : kind === 'seller'
            ? sellerToast
            : 'Seller/Vendor account connected',
        'success'
      );
      void qc.invalidateQueries({ queryKey: SP_API_OAUTH_CONNECTIONS_QUERY_KEY });
    } else if (spapi === 'error') {
      showToast(searchParams.get('message') || 'Seller/Vendor authorization failed', 'error');
    }
    const next = new URLSearchParams(searchParams);
    next.delete('spapi');
    next.delete('message');
    next.delete('credential_id');
    next.delete('type');
    next.delete('created');
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams, showToast, qc]);

  return (
    <div className="p-6 max-w-2xl space-y-8">
      <div>
        <div className="flex flex-wrap items-center gap-3 text-body-sm text-foreground-muted mb-2">
          <Link to="/admin/users" className="hover:text-foreground hover:underline">
            Admin
          </Link>
          <span aria-hidden>/</span>
          <span className="text-foreground">SP-API settings</span>
        </div>
          <div className="flex items-center justify-between gap-4">
            <h1 className="text-headline-md font-semibold text-foreground mb-1">Admin settings</h1>
            <SignOutButton />
          </div>
        <p className="text-body-sm text-foreground-muted">
          Super admin only. Connect Seller Central and Vendor Central (OAuth or self-authorized
          refresh token) to pull retail sales and ASIN data.
        </p>
      </div>

      <SpApiConnectionsPanel />
    </div>
  );
}
